<template>
    <div>
        
        <vs-prompt @cancel="val=''" blur @accept="acceptAlert" @close="close" :active.sync="activePrompt"
            accept-text="Add" title="Add New Story">
            <div class="con-exemple-prompt">
                <vs-input placeholder="Arabic Name" v-model="story.ar_name" />
                <vs-input placeholder="English Name" v-model="story.en_name" />

            </div>
        </vs-prompt>
         <vs-table :data="stories.data" stripe v-if="stories.length !=0">
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                <div class="flex flex-wrap-reverse items-center">
                    <div @click="$router.push({name:'storiesCreate'})"
                        class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary">
                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                        <span class="ml-2 text-base text-primary">Add New Story</span>
                    </div>
                </div>
                
            </div>
            <template #thead>
                <vs-th>Body</vs-th>
                <vs-th>Views</vs-th>
                <vs-th>Likes</vs-th>
                <vs-th>User</vs-th>
                <vs-th>Status</vs-th>
                <vs-th>Dedline</vs-th>
                <vs-th>Actions</vs-th>
            </template>
            <template slot-scope="{data}">
                <tbody>
                    <vs-tr v-for="(story,index) in data" :key="index">
                        <vs-td class="img-container">
                            <img :src="`${$baseUrl}/uploads/stories/${story.media}`" class="product-img" width="100px" height="150px"/>
                        </vs-td>
                         <vs-td>{{story.views}}</vs-td>
                        <vs-td>{{story.likes_count}}</vs-td>
                        <vs-td><a>{{story.user_data.name}}</a></vs-td>
                        <vs-td >
                            <vs-chip v-if="story.status==0" color="orange" >
                                Pending
                            </vs-chip>
                            <vs-chip v-if="story.status==2" color="danger" >
                                Refused 
                            </vs-chip>
                            <vs-chip v-if="story.status==1" color="success"  >
                                Approved 
                            </vs-chip>
                        </vs-td>
                        <vs-td>{{story.comments_count}}</vs-td>
                        <vs-td class="whitespace-no-wrap">
                            <!-- <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                @click="edit(story)" /> -->
                            <feather-icon :icon="story.status==1?'EyeOffIcon':'EyeIcon'" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                class="ml-2" @click="changeStatus(story)" />
                            <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                class="ml-2" @click="openConfirm(story)" />
                        </vs-td>
                    </vs-tr>
                </tbody>
            </template>
        </vs-table>
        <vs-pagination v-if="stories.length !=0" :total="stories.last_page" v-model="page"></vs-pagination>
    </div>
</template>
<script>

    export default {
        data() {
            return {
                stories:[],
                select1: 2,
                loading:false,
                activePrompt: false,
                delConfirm: false,
                val: '',
                page:1,
                query:'',
                def_story: {
                    id: 0,
                    body: '',
                    media: ''
                },
                story: {
                    id: 0,
                    body: '',
                    media: ''
                }
            }
        },
        created() {
            this.$store.dispatch('auth/info')
            this.getStories();
        },
        watch: {
      page() {
        this.getStories();
      },
      query(val) {
        this.getStories();
      },
    },
        methods: {
            getStories(){
          this.loading=true;
          this.axios.get(`${this.$apiUrl}/stories?page=${this.page}`).then(res=>{
            this.stories=res.data;
            this.loading=false;
          })
        },
            changeStatus(story){
                this.story=story;
                this.$vs.dialog({
                    type: 'confirm',
                    color:story.status==1?'warning':'success',
                    title:story.status==1?'Story Hidden': `Story approval`,
                    text:story.status==1?'Are you sure you want to make the story invisible?':  'Are you sure you want to make the story visible?',
                      accept:this.storyStatus,
                      close:this.close
                })
            },
            openConfirm(story) {
                this.story=story;
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: `Delete story`,
                    text: 'Are you sure to delete this item ?',
                    accept:this.del,
                    close:this.close
                })
            },
            acceptAlert(color) {
                const data = new FormData();
                data.append('id', this.story.id);
                data.append('ar_name', this.story.ar_name);
                data.append('en_name', this.story.en_name);
                this.axios.post(`${this.$apiUrl}/stories`, data).then(res => {
                    this.story = this.def_story;
                    if (res.status == 200) {
                        this.$vs.notify({
                            color: 'success',
                            title: 'story Addedd',
                            text: res.data.response.en_name
                        })
                    }
                    this.getStories();
                })

            },
            close() {
                this.story = this.def_story;
            },
            storyStatus(){
                this.axios.post(`${this.$apiUrl}/stories/status/${this.story.id}`).then(res => {
                    this.story = this.def_story;
                    if (res.status == 200) {
                        this.$vs.notify({
                            color: 'success',
                            title: 'story Updated !',
                            text: res.data.response.en_name
                        })
                    }
                    this.getStories();
                })
            },
            edit(story) {
                this.story = story;
                this.activePrompt = true;
            },
            del() {
                 this.axios.post(`${this.$apiUrl}/stories/delete/${this.story.id}`).then(res => {
                    this.story = this.def_story;
                    if (res.status == 200) {
                        this.$vs.notify({
                            color: 'warning',
                            title: 'story Deleted !',
                            text: res.data.response.en_name
                        })
                    }
                    this.page=1;
                    this.getStories();
                })

            },
        }
    }
</script>
<style lang="scss">
    .con-exemple-prompt {
        padding: 10px;
        padding-bottom: 0px;

        .vs-input {
            width: 100%;
            margin-top: 10px;
        }

    }
</style>